import React from 'react';

import './style.css';

const NotFound: React.FC = () => {
    return (
        <div className="not-found">
            <div className="not-found-box">
                <img className="exclamation-circle" alt="" src="/img/fs_exclamation-circle-red.svg" />
                <div className="text-wrapper">
                    Sorry, this page is not available.
                </div>
                <img className="line" alt="Line" src="/img/fs_line-23.svg" />
                <div className="div">
                    The session may have been deleted or the link is no longer working. Please check the link try again.
                </div>
                <div className="text-wrapper-2">
                    www.thebackninegolf.com
                </div>
            </div>
        </div>
    );
};

export default NotFound;